export const LoadingImage = ({ imgLoading }) => {
    // image is only rendered if the full form has NOT successfully loaded

    return (
        <div className='veil'>
            <div style={{ textAlign: 'center' }}>
                <img
                    src={imgLoading}
                    alt={'Loading...'}
                    style={{
                        height: '100px',
                        width: '100px',
                    }}
                />
            </div>
        </div>
    )
}
